var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisableEnvelop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#D7D7D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7V12.07L17.3375 12.88L14 15.1L11 13.0975L10.6775 12.8875L9.5 12.07V7C9.5 6.60218 9.65804 6.22064 9.93934 5.93934C10.2206 5.65804 10.6022 5.5 11 5.5H17C17.3978 5.5 17.7794 5.65804 18.0607 5.93934C18.342 6.22064 18.5 6.60218 18.5 7Z",
    fill: "#6B6B6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 11.8V19.06C21.4845 19.4474 21.3196 19.8137 21.04 20.0821C20.7604 20.3506 20.3876 20.5004 20 20.5H8C7.61236 20.5004 7.23964 20.3506 6.96 20.0821C6.68036 19.8137 6.51551 19.4474 6.5 19.06V11.8L6.5975 11.8675L7.1225 12.235L8 12.8425L9.8375 14.125L13.5875 16.6225C13.6073 16.6266 13.6277 16.6266 13.6475 16.6225C13.6788 16.6451 13.7146 16.6604 13.7525 16.6675H13.7975C13.9054 16.6976 14.0196 16.6976 14.1275 16.6675H14.1725C14.2104 16.6604 14.2462 16.6451 14.2775 16.6225C14.2973 16.6266 14.3177 16.6266 14.3375 16.6225L18.0875 14.125L20 12.85L20.885 12.25L21.4025 11.8825L21.5 11.8Z",
    fill: "#6B6B6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49992 8.875V10.75L8.59242 11.4325L7.29492 10.5325L9.49992 8.875Z",
    fill: "#6B6B6C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.705 10.5325L19.4075 11.4325L18.5 10.75V8.875L20.705 10.5325Z",
    fill: "#6B6B6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableEnvelop);
export default __webpack_public_path__ + "static/media/disable_envelop.88aeeb439320a87b601a282852959ba3.svg";
export { ForwardRef as ReactComponent };